import { RoomCategory } from '@/types'

export const ROOM_CATEGORY_TO_DISPLAY_NAME: Record<RoomCategory, string> = {
  [RoomCategory.MASTER]: 'Master',
  [RoomCategory.CUSTOM]: 'Custom',
}
